import { useEffect, useRef } from 'react';

const ProjectListeners = ({ eventEmitter, applyStoreAction, delayedApplyStoreAction, currentUserId }) => {
    const currentUserIdRef = useRef(currentUserId);

    useEffect(() => {
        currentUserIdRef.current = currentUserId;
    }, [currentUserId]);

    const listen = () => {
        eventEmitter.on('project_added', payload => {
            delayedApplyStoreAction({
                type: 'PROJECT_ADD_SOCKET',
                payload: {
                    project: payload.data || payload
                }
            });
        });

        eventEmitter.on('project_edited', project => {
            if (project.id && [...project.members, project.owner].includes(currentUserIdRef.current)) {
                applyStoreAction({
                    type: 'PROJECT_UPDATE_SOCKET',
                    payload: {
                        projectId: project.id,
                        project
                    }
                });
            }
        });

        eventEmitter.on('project_archived', ({ id: projectId }) => {
            applyStoreAction({
                type: 'PROJECT_UPDATE_SOCKET',
                payload: {
                    projectId,
                    project: {
                        archived: true
                    }
                }
            });
        });

        eventEmitter.on('project_unarchived', ({ id: projectId }) => {
            applyStoreAction({
                type: 'PROJECT_UPDATE_SOCKET',
                payload: {
                    projectId,
                    project: {
                        archived: false
                    }
                }
            });
        });

        eventEmitter.on('project_removed', ({ project_id: projectId }) => {
            applyStoreAction({
                type: 'PROJECT_REMOVE_SOCKET',
                payload: {
                    projectId
                }
            });
        });

        eventEmitter.on('project_start', ({ id: projectId }) => {
            applyStoreAction({
                type: 'PROJECT_START_SOCKET'
            });
        });

        eventEmitter.on('project_kicked', ({ project_id: projectId }) => {
            applyStoreAction({
                type: 'PROJECT_KICK_SOCKET',
                payload: {
                    projectId
                }
            });
        });
    }

    useEffect(listen, []);

    return null;
}

export default ProjectListeners;
